import { Chart } from 'chart.js';

// Shared precipitation (mm) label for the weather block (#3254/#3923).
// Drawn directly under the weather icon, locale-formatted (comma vs. point)
// via Intl.NumberFormat instead of a hardcoded separator. Missing values
// render as the agreed "–" placeholder rather than NaN/undefined.

const MISSING_VALUE_PLACEHOLDER = '–';

export const precipitationPlugin = {
  id: 'precipitationPlugin',

  afterDatasetsDraw: (chart: Chart) => {
    const dataset = (chart.data?.datasets as any)?.[0];
    const precipitation: Array<number | null> = dataset?.precipitation;
    if (!precipitation?.length) return;

    const xAxis = (chart.scales as any)['x'];
    if (!xAxis) return;

    // mirror the axis's own autoSkip decision, otherwise this row draws one label per raw
    // data index and overlaps into unreadable text once autoSkip starts hiding tick labels
    const visibleIndices = new Set((xAxis.ticks as { value: number }[])?.map(tick => tick.value));

    const locale: string = dataset?.locale ?? 'en-US';
    const formatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

    const ctx = chart.ctx;
    // icon (labelIcon.ts) occupies [xAxis.top + 5, xAxis.top + 29]; draw right underneath it
    const y = xAxis.top + 29 + 4;

    ctx.save();
    ctx.font = '11px sans-serif';
    ctx.fillStyle = '#1b4d8f';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';

    precipitation.forEach((mm, index) => {
      if (!visibleIndices.has(index)) return;
      const x = xAxis.getPixelForValue(index);
      const label = mm == null ? MISSING_VALUE_PLACEHOLDER : `${formatter.format(mm)} mm`;
      ctx.fillText(label, x, y);
    });

    ctx.restore();
  },
};
